import React from 'react'
import { Route, Redirect, useHistory,useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import util from '../../util/util'
import PropTypes from 'prop-types'
import serviceInterface from '../../services/service.interface'
import { logout } from '../../store/action/profile.action'
import { constants } from '../../constants'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const history = useHistory()
  let location = useLocation()
  var verifyRoles = (roles = [], current_user = {}) => {
    if (roles.length == 0) return true
    return serviceInterface.AuthService().authorize_role(roles, current_user)
  }
  var checkForLogin = (flag, customer, current_user) => {
    if (!flag) return true
    if (!(customer && customer._id)) {
      if (
        current_user.role.toString() == constants.ROLE.COMPANY_ADMIN ||
        current_user.role.toString() == constants.ROLE.COMPANY_HEALTHCOACH
      ) {
        history.push('/customers')
        return true
      }
      return false
    }
    return true
  }

  var checkForCompanyLogin = (flag, company, current_user) => {
    if (!flag) return true
    if (!(company && company._id)) {
      if (
        current_user.role.toString() == constants.ROLE.COMPANY_ADMIN ||
        current_user.role.toString() == constants.ROLE.COMPANY_HEALTHCOACH
      ) {
        history.push('/login')
        return true
      }
      return false
    }
    return true
  }
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    // Also check the role if given
    <Route
      {...rest}
      render={(props) => {
        if (
          rest.decoded == undefined ||
          !verifyRoles(rest.roles, rest.decoded) ||
          !checkForLogin(rest.checkForLogin, rest.customer, rest.decoded) ||
          !checkForCompanyLogin(
            rest.checkForCompanyLogin,
            rest.company,
            rest.decoded
          )
        )
          rest.logoutapp()
        return rest.decoded != undefined ? (
          <Component {...rest} />
        ): location.search === constants.ADMIN_LITE ? (
            <Redirect to={{ pathname: '/', search: constants.ADMIN_LITE }} />
        )  : (
          <Redirect to='/login' />
        )
      }}
    />
  )
}

PrivateRoute.propTypes = {
  token: PropTypes.string,
  logoutapp: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    decoded: util.verifyToken(state.profile.token, true),
    customer: state.profile.customer,
    company: state.profile.company,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logoutapp: () => dispatch(logout()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)
